import { Tab } from "@headlessui/react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import React, { FC, Fragment,useCallback,useEffect,useState } from "react";
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import ModalSelectDate from "components/ModalSelectDate";
import moment from "moment";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ModalSelectGuests from "components/ModalSelectGuests";
import { GuestsObject } from "components/HeroSearchForm2Mobile/GuestsInput";
import axios from "axios";
import useAuth from "components/Authprovider/Auth";
import { useHistory, useParams } from "react-router-dom";
import { HotelType, offerType } from "data/types";
import { diffDays } from "./ListingStayDetailPage";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import toast from "react-hot-toast";
import history from "hooks/history";
import { useLocalStorage } from "components/Authprovider/useLocalStorage";


export interface CheckOutPageProps {
  className?: string;
}

type typeParams = {
  id: any;
};



const CheckOutPageMobile: FC<CheckOutPageProps> = ({ className = "" }) => {

  const {setBooking,token} = useAuth()
  const navigater = useHistory()
 
  //////////////////////////////////////////////////////////////////
  const [rangeDates, setRangeDates] = useState<DateRage>({
    startDate: moment().add(1, "day"),
    endDate: moment().add(5, "days"),
  });
  const [guests, setGuests] = useState<GuestsObject>({
    guestAdults: 2,
    guestChildren: 1,
    guestInfants: 1,
  });

  const [offerSelected, setOfferSelected] = useState("")
  const [offerPrice, setOfferPrice] = useState(0)
  const [rooms, setRooms] = useState(1)
  const [guest, setGuest] = useState(1)
  const [total, setTotal] = useState(0)
  /////////////////////////////////////////////////////////////
  const { id } = useParams<typeParams>();

  const [data,setData] = useState<HotelType>()
  const [offer,setOffers] = useState<offerType[]>()


  ///////////////////////////////////////////////////////////
/**
 * Create a new new booking
 */
const checkIn = rangeDates.startDate?.format('YYYY-MM-DD HH:mm:ss');
  const checkOut = rangeDates.endDate?.format('YYYY-MM-DD HH:mm:ss');

  const room_type = offerSelected.toLowerCase()

  const handleBooking = async ()=>{


    const data = {hotel_id: id,number_of_guests: guest,number_of_rooms: rooms,room_type: room_type,daily_price: offerPrice,total_price: total,check_in_date: checkIn,check_out_date: checkOut};

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization": "Bearer " +token},
      body: JSON.stringify(data),
    };

    const postData = fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id+'/booking', requestOptions)

    toast.promise(postData, {
      loading: "Creating a booking....",
      success: (data: any) => `Successful`,
      error: (error) => `Unable to make booking`,
    });

    postData.then((data: any) => {
      // Use setData to update the state with the data
      navigater.push("/bookings");
    });
    
    
  }

  ///////////////////////////////////////////////////////////

  const calcTotal = useCallback(() => {

    if (offerPrice && rangeDates && rooms && rooms >= 1){

      const totalAmount = diffDays(rangeDates.startDate,rangeDates.endDate)*offerPrice*rooms;
      setTotal(totalAmount)

    }else if(data?.daily_room_price && rangeDates && rooms && rooms >= 1 ){

      const totalAmount = diffDays(rangeDates.startDate,rangeDates.endDate)*data.daily_room_price*rooms;
      setTotal(totalAmount)

    }

  },[offerPrice,rangeDates,rooms,data?.daily_room_price])

  useEffect(()=>{
    calcTotal()
    console.log(total)
  },[offerPrice,rangeDates,rooms])

  useEffect(() =>{
    const getHotels = async ()=>{
      try {

        const response = await fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id,{
          headers: {'Accept': 'application/json','Authorization': 'Bearer '+token},
        });
        const data = await response.json();

        if(data && data.status_code === 200){

          const hotel = data.data
          console.log(hotel)
          setData(hotel)

        }
        return true

      }catch(error){

        throw(error)

      }
      
    }

    const getAccommodations = async ()=>{
      try {

        const response = await fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id+'/accommodation-offers',{
          headers: {'Accept': 'application/json','Authorization': 'Bearer '+token},
        });
        const data = await response.json();


        if(data){
          console.log(data)
          setOffers(data)
        }
        return true
      }catch(error){
        throw(error)
      }
      
    }
    getHotels();
    getAccommodations();
  },[id])

  const onOptionChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value)
    setOfferSelected(e.target.value)
  }

  const renderRadio = (
    data: offerType,
    name: string,
    id: string,
    label: string,
    key?: any,
  ) => {
    return (
      <div className="flex items-center" key={key}>
        <input
          id={id}
          name={name}
          type="radio"
          value={id}
          checked={offerSelected === id}
          onChange={(e)=>{
            onOptionChange(e)  
            setOfferPrice(data.daily_price)
          }}
          className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
        />
        <label
          htmlFor={id + name}
          className="ml-3 block text-sm font-medium text-neutral-700 dark:text-neutral-300"
        >
          {label}
        </label>
      </div>
    );
  };

  
  const renderMain = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">
          Create a new bookinng
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div className="flex justify-between">
            <span className="text-3xl font-semibold">
              ${offerPrice ? offerPrice : data?.daily_room_price}
              <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
                /night
              </span>
            </span>
            <StartRating />
          </div>
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            <ModalSelectDate
              defaultValue={rangeDates}
              onSelectDate={setRangeDates}
              renderChildren={({ openModal }) => (
                <button
                  onClick={openModal}
                  className="text-left flex-1 p-5 flex justify-between space-x-5 "
                  type="button"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Date</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      {converSelectedDateToString(rangeDates)}
                    </span>
                  </div>
                  <PencilSquareIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
            />
            <div className="w-full border border-neutral-200 dark:border-neutral-700"></div>
            <div className="relative flex items-center justify-evenly px-5 py-6 ">
              {offer &&(
                offer.map((offer) => (
                  renderRadio(offer,"Offer", offer.room_type,`${offer.room_type} ($${offer.daily_price})`,offer.created_at)
                ))
              )}
            </div>
            <div className="w-full border border-neutral-200 dark:border-neutral-700"></div>
            <div className="relative flex flex-col px-5 py-6 space-y-5">
              <NcInputNumber label="Number of rooms" min={1} max={10} defaultValue={rooms} onChange={(value)=> setRooms(value)}/>
            </div>
            <div className="w-full border border-neutral-200 dark:border-neutral-700"></div>
            <div className="relative flex flex-col px-5 py-6 space-y-5">
              <NcInputNumber label="Number of guests" min={1} max={10} defaultValue={guest} onChange={(value)=> setGuest(value)}/>
            </div>
            {/*<ModalSelectGuests
              defaultValue={guests}
              onChangeGuests={setGuests}
              renderChildren={({ openModal }) => (
                <button
                  type="button"
                  onClick={openModal}
                  className="text-left flex-1 p-5 flex justify-between space-x-5"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Guests</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      <span className="line-clamp-1">
                        {`${
                          (guests.guestAdults || 0) +
                          (guests.guestChildren || 0)
                        } Guests, ${guests.guestInfants || 0} Infants`}
                      </span>
                    </span>
                  </div>
                  <PencilSquareIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
                      />*/}
          </div>
        </div>
        {/* SUM */}
        <div className="flex flex-col space-y-4">
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>${offerPrice ? offerPrice : data?.daily_room_price} x {diffDays(rangeDates.startDate,rangeDates.endDate)} nights</span>
            <span>x {rooms} rooms</span>
          </div>
        {/*<div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>%5</span>
          </div>*/}
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>${total}</span>
          </div>
        </div>
        
        <ButtonPrimary onClick={handleBooking}>Book Now</ButtonPrimary>
        
      </div>
    );
  };

  return (
    <div className={`nc-CheckOutPage ${className}`} data-nc-id="CheckOutPage">
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10 ">{renderMain()}</div>
      </main>
    </div>
  );
};

export default CheckOutPageMobile;
